export default {
  "content": "<path d=\"M6.798 5L4 2.115 1.202 5 0 3.761 3.4.257a.831.831 0 011.2 0L8 3.76z\" fill=\"#028EB7\"/>",
  "attrs": {
    "height": "5",
    "viewBox": "0 0 8 5",
    "width": "8",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};